import Block from '../../common.blocks/block'

export default class CheckoutShipping extends Block {
	static title = 'checkout-shipping'

	constructor($el) {
		super($el)

		this.$el.on('change', () => {
			this.$el.submit()
		})
	}
}
